// extracted by mini-css-extract-plugin
module.exports = {"__banner":"Banner___banner_301IK"};